import React from 'react';
import CameraViewIcon from './CameraViewIcon';

export const IconDefault = () => (
  <CameraViewIcon width="64.542" height="24.859" viewBox="0 0 64.542 24.859">
    <g transform="translate(0.271 0.271)">
      <path
        d="M16.286,45.265a.5.5,0,0,1-.5-.478c-.041-.913-.143-1.716-.227-2.313-.079-.562-.16-1.056-.246-1.508-.083-.436-.149-.723-.181-.855-.009-.039-.017-.07-.024-.094-.147-.006-.414-.011-.891-.014a.5.5,0,1,1,.006-1c1.22.008,1.3.016,1.486.159a.977.977,0,0,1,.24.272,1.525,1.525,0,0,1,.154.443c.034.141.1.445.191.9s.172.977.254,1.555c.088.62.193,1.454.236,2.409a.5.5,0,0,1-.477.522Z"
        transform="translate(-7.716 -21.431)"
        fill="currentColor"
      />
      <path
        d="M9.71,45.265H9.688a.5.5,0,0,1-.477-.522c.042-.955.148-1.789.236-2.409.08-.565.163-1.073.254-1.555.087-.456.157-.761.191-.9a1.565,1.565,0,0,1,.152-.441.976.976,0,0,1,.239-.273c.184-.144.268-.153,1.489-.161a.5.5,0,1,1,.006,1c-.477,0-.744.008-.891.014-.006.024-.014.055-.024.094-.032.132-.1.42-.181.854-.088.465-.168.959-.246,1.508-.084.6-.187,1.4-.227,2.314A.5.5,0,0,1,9.71,45.265Z"
        transform="translate(-5.268 -21.431)"
        fill="currentColor"
      />
      <path
        d="M0,3.186a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.686A.5.5,0,0,1,0,3.186Z"
        transform="translate(31.304 4.736)"
        fill="currentColor"
      />
      <path
        d="M1.091.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.091a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.091.5Z"
        transform="translate(30.214 4.736)"
        fill="currentColor"
      />
      <path
        d="M0,3.249a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.749A.5.5,0,0,1,0,3.249Z"
        transform="translate(30.214 4.736)"
        fill="currentColor"
      />
      <path
        d="M2.859.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H2.859a.5.5,0,0,1,.5.5A.5.5,0,0,1,2.859.5Z"
        transform="translate(54.129 21.419)"
        fill="currentColor"
      />
      <path
        d="M0,2.116a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V1.616A.5.5,0,0,1,0,2.116Z"
        transform="translate(54.129 21.418)"
        fill="currentColor"
      />
      <path
        d="M2.7.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H2.7a.5.5,0,0,1,.5.5A.5.5,0,0,1,2.7.5Z"
        transform="translate(54.129 23.034)"
        fill="currentColor"
      />
      <path
        d="M130.772,45.265a.5.5,0,0,1-.5-.478c-.041-.913-.143-1.716-.227-2.313-.079-.562-.16-1.056-.246-1.508-.083-.436-.149-.723-.181-.855-.009-.039-.017-.07-.024-.094-.147-.006-.414-.011-.891-.014a.5.5,0,0,1,0-1h0c1.22.008,1.3.016,1.486.159a.977.977,0,0,1,.24.272,1.526,1.526,0,0,1,.154.443c.034.141.1.445.191.9s.172.977.254,1.555c.088.62.193,1.454.236,2.409a.5.5,0,0,1-.477.522Z"
        transform="translate(-69.827 -21.431)"
        fill="currentColor"
      />
      <path
        d="M124.2,45.265h-.023a.5.5,0,0,1-.477-.522c.042-.955.148-1.789.236-2.409.08-.57.164-1.079.254-1.555.078-.415.147-.719.19-.9a1.569,1.569,0,0,1,.152-.442.976.976,0,0,1,.239-.273c.184-.144.268-.153,1.489-.161a.5.5,0,1,1,.006,1c-.477,0-.744.008-.891.014-.006.024-.014.055-.024.094-.033.139-.1.437-.18.854-.088.461-.168.955-.246,1.509-.084.6-.187,1.4-.227,2.314A.5.5,0,0,1,124.2,45.265Z"
        transform="translate(-67.379 -21.431)"
        fill="currentColor"
      />
      <path
        d="M0,3.371a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.871A.5.5,0,0,1,0,3.371Z"
        transform="translate(4.003 4.722)"
        fill="currentColor"
      />
      <path
        d="M1.155.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.155a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.155.5Z"
        transform="translate(2.848 4.722)"
        fill="currentColor"
      />
      <path
        d="M0,1.162a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.662A.5.5,0,0,1,0,1.162Z"
        transform="translate(31.644 3.623)"
        fill="currentColor"
      />
      <path
        d="M29.119.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H29.119a.5.5,0,0,1,.5.5A.5.5,0,0,1,29.119.5Z"
        transform="translate(2.525 3.623)"
        fill="currentColor"
      />
      <path
        d="M0,1.108a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.608A.5.5,0,0,1,0,1.108Z"
        transform="translate(2.525 3.623)"
        fill="currentColor"
      />
      <path
        d="M49.215.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H49.215a.5.5,0,0,1,.5.5A.5.5,0,0,1,49.215.5Z"
        transform="translate(8.086 19.426)"
        fill="currentColor"
      />
      <path
        d="M26.2.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H26.2a.5.5,0,0,1,.5.5A.5.5,0,0,1,26.2.5Z"
        transform="translate(4.009 4.93)"
        fill="currentColor"
      />
      <path
        d="M61.241.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H61.241a.5.5,0,0,1,.5.5A.5.5,0,0,1,61.241.5Z"
        transform="translate(1.388 7.422)"
        fill="currentColor"
      />
      <path
        d="M.963.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H.963a.5.5,0,0,1,.5.5A.5.5,0,0,1,.963.5Z"
        transform="translate(61.666 11.681)"
        fill="currentColor"
      />
      <path
        d="M4.44,2.492a.5.5,0,0,1-.2-.044L-.2.456A.5.5,0,0,1-.456-.2.5.5,0,0,1,.2-.456l4.44,1.992a.5.5,0,0,1-.2.956Z"
        transform="translate(49.85 19.426)"
        fill="currentColor"
      />
      <path
        d="M7.978,3.986a.5.5,0,0,1-.2-.042L-.2.458A.5.5,0,0,1-.458-.2.5.5,0,0,1,.2-.458L8.178,3.028a.5.5,0,0,1-.2.958Z"
        transform="translate(46.151 19.426)"
        fill="currentColor"
      />
      <path
        d="M0,4.173a.5.5,0,0,1-.458-.3A.5.5,0,0,1-.2,3.215L8.146-.458A.5.5,0,0,1,8.8-.2a.5.5,0,0,1-.256.659L.2,4.131A.5.5,0,0,1,0,4.173Z"
        transform="translate(8.558 19.426)"
        fill="currentColor"
      />
      <path
        d="M0,2.6a.5.5,0,0,1-.458-.3A.5.5,0,0,1-.2,1.646L4.61-.458A.5.5,0,0,1,5.269-.2a.5.5,0,0,1-.258.658L.2,2.562A.5.5,0,0,1,0,2.6Z"
        transform="translate(8.413 19.426)"
        fill="currentColor"
      />
      <path
        d="M129.407,52.26A1.251,1.251,0,0,1,128.156,51a.5.5,0,0,1,1,0,.251.251,0,1,0,.5,0,.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,.5.5,1.251,1.251,0,0,1-1.251,1.256Z"
        transform="translate(-69.799 -27.672)"
        fill="currentColor"
      />
      <path
        d="M15.011,52.26A1.251,1.251,0,0,1,13.76,51a.5.5,0,0,1,1,0,.251.251,0,1,0,.5,0,.5.5,0,0,1,1,0,1.251,1.251,0,0,1-1.251,1.256Z"
        transform="translate(-7.736 -27.672)"
        fill="currentColor"
      />
      <path
        d="M4.128.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H4.128a.5.5,0,0,1,.5.5A.5.5,0,0,1,4.128.5Z"
        transform="translate(56.817 23.334)"
        fill="currentColor"
      />
      <path
        d="M4.128.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H4.128a.5.5,0,0,1,.5.5A.5.5,0,0,1,4.128.5Z"
        transform="translate(4.442 23.334)"
        fill="currentColor"
      />
      <path
        d="M0,1.284a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.784A.5.5,0,0,1,0,1.284Z"
        transform="translate(31.538 10.324)"
        fill="currentColor"
      />
      <path
        d="M0,1.284a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.784A.5.5,0,0,1,0,1.284Z"
        transform="translate(29.483 10.324)"
        fill="currentColor"
      />
      <path
        d="M0,1.284a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.784A.5.5,0,0,1,0,1.284Z"
        transform="translate(4.724 10.324)"
        fill="currentColor"
      />
      <path
        d="M0,1.284a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.784A.5.5,0,0,1,0,1.284Z"
        transform="translate(2.659 10.324)"
        fill="currentColor"
      />
      <path
        d="M29.137.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H29.137a.5.5,0,0,1,.5.5A.5.5,0,0,1,29.137.5Z"
        transform="translate(2.528 9.336)"
        fill="currentColor"
      />
      <path
        d="M0,1.488a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.988A.5.5,0,0,1,0,1.488Z"
        transform="translate(31.665 9.336)"
        fill="currentColor"
      />
      <path
        d="M0,1.488a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V.988A.5.5,0,0,1,0,1.488Z"
        transform="translate(2.528 9.336)"
        fill="currentColor"
      />
      <path
        d="M.693.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H.693a.5.5,0,0,1,.5.5A.5.5,0,0,1,.693.5Z"
        transform="translate(31.753 11.681)"
        fill="currentColor"
      />
      <path
        d="M1.115.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.115a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.115.5Z"
        transform="translate(1.351 11.681)"
        fill="currentColor"
      />
      <path
        d="M29.22.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H29.22a.5.5,0,0,1,.5.5A.5.5,0,0,1,29.22.5Z"
        transform="translate(32.446 17.523)"
        fill="currentColor"
      />
      <path
        d="M29.22.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H29.22a.5.5,0,0,1,.5.5A.5.5,0,0,1,29.22.5Z"
        transform="translate(32.446 11.108)"
        fill="currentColor"
      />
      <path
        d="M29.288.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H29.288a.5.5,0,0,1,.5.5A.5.5,0,0,1,29.288.5Z"
        transform="translate(2.466 17.523)"
        fill="currentColor"
      />
      <path
        d="M29.288.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H29.288a.5.5,0,0,1,.5.5A.5.5,0,0,1,29.288.5Z"
        transform="translate(2.466 11.108)"
        fill="currentColor"
      />
      <path
        d="M0,6.914a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V6.414A.5.5,0,0,1,0,6.914Z"
        transform="translate(61.666 11.108)"
        fill="currentColor"
      />
      <path
        d="M0,6.914a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V6.414A.5.5,0,0,1,0,6.914Z"
        transform="translate(32.446 11.108)"
        fill="currentColor"
      />
      <path
        d="M0,6.914a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V6.414A.5.5,0,0,1,0,6.914Z"
        transform="translate(31.753 11.108)"
        fill="currentColor"
      />
      <path
        d="M0,6.914a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V6.414A.5.5,0,0,1,0,6.914Z"
        transform="translate(2.466 11.108)"
        fill="currentColor"
      />
      <path
        d="M0,17.165a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V16.665A.5.5,0,0,1,0,17.165Z"
        transform="translate(62.629 0.839)"
        fill="currentColor"
      />
      <path
        d="M1.142.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.142a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.142.5Z"
        transform="translate(62.629 17.504)"
        fill="currentColor"
      />
      <path
        d="M138.043,1.657a.5.5,0,0,1-.5-.5.071.071,0,1,0-.142,0,.5.5,0,0,1-1,0,1.071,1.071,0,1,1,2.142,0A.5.5,0,0,1,138.043,1.657Z"
        transform="translate(-74.272 -0.318)"
        fill="currentColor"
      />
      <path
        d="M0,17.165a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V16.665A.5.5,0,0,1,0,17.165Z"
        transform="translate(63.771 0.839)"
        fill="currentColor"
      />
      <path
        d="M0,3.371a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V2.871A.5.5,0,0,1,0,3.371Z"
        transform="translate(2.848 4.722)"
        fill="currentColor"
      />
      <path
        d="M1.188.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H1.188a.5.5,0,0,1,.5.5A.5.5,0,0,1,1.188.5Z"
        transform="translate(0.229 17.53)"
        fill="currentColor"
      />
      <path
        d="M1.688,1.595a.5.5,0,0,1-.5-.5.094.094,0,0,0-.188,0,.5.5,0,1,1-1,0,1.094,1.094,0,0,1,2.188,0A.5.5,0,0,1,1.688,1.595Z"
        transform="translate(-0.271 -0.272)"
        fill="currentColor"
      />
      <path
        d="M0,17.207a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V16.707A.5.5,0,0,1,0,17.207Z"
        transform="translate(1.417 0.823)"
        fill="currentColor"
      />
      <path
        d="M0,17.207a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5.5.5,0,0,1,.5,0V16.707A.5.5,0,0,1,0,17.207Z"
        transform="translate(0.229 0.823)"
        fill="currentColor"
      />
    </g>
  </CameraViewIcon>
);

export default IconDefault;
